export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full py-6 mt-auto overflow-x-hidden">
      <div className="w-full max-w-6xl mx-auto px-4 box-border">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-gray-600 text-sm">
          <p>© {currentYear} Star Micronics America, Inc. All rights reserved.</p>
          <a
            href="https://www.starmicronics.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-900 transition-colors"
          >
            starmicronics.com
          </a>
        </div>
      </div>
    </footer>
  );
}
